import React from 'react';
import type { RouteObject } from 'react-router-dom';

const FavoritesPage = React.lazy(() => import('@/pages/map'));
const TimelinePage = React.lazy(() => import('@/pages/map/timeline'));

export const mapRoutes: RouteObject[] = [
  {
    path: 'map',
    element: <FavoritesPage />,
  },
  {
    path: 'timeline',
    element: <TimelinePage />,
  },
];
